<template>
    <div class="uses-tailwind">
        <div class="overflow-x-auto border border-gray-300 rounded-md">
            <table class="w-full text-sm border-collapse">
                <thead>
                    <tr class="bg-gray-100">
                        <th class="px-3 py-2 text-left font-semibold border-b-2 border-gray-300">
                            {{ trans('pages.production_progress.product_number') }}
                        </th>
                        <th class="px-3 py-2 text-left font-semibold border-b-2 border-gray-300">
                            {{ trans('pages.production_progress.customer') }}
                        </th>
                        <th class="px-3 py-2 text-left font-semibold border-b-2 border-gray-300">
                            {{ trans('pages.production_progress.product_type') }}
                        </th>
                        <th class="px-3 py-2 text-left font-semibold border-b-2 border-gray-300">
                            {{ trans('pages.production_progress.route_number') }}
                        </th>
                        <th class="px-3 py-2 text-left font-semibold border-b-2 border-gray-300">
                            {{ trans('pages.production_progress.status') }}
                        </th>
                        <th class="px-3 py-2 text-left font-semibold border-b-2 border-gray-300">
                            {{ trans('pages.production_progress.production_date') }}
                        </th>
                        <th class="px-3 py-2 text-left font-semibold border-b-2 border-gray-300">
                            {{ trans('pages.production_progress.delivery_date') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="product in organizedProducts"
                        :key="product.productId"
                        :class="getRowClass(product)"
                        :title="getRowTitle(product)"
                    >
                        <td class="px-3 py-2 border-b border-gray-200" :class="{ 'pl-8': product.isChild }">{{ product.productNumber }}</td>
                        <td class="px-3 py-2 border-b border-gray-200">{{ product.customerName }}</td>
                        <td class="px-3 py-2 border-b border-gray-200">{{ product.productTypeName }}</td>
                        <td class="px-3 py-2 border-b border-gray-200">{{ product.routeNumber }}</td>
                        <td class="px-3 py-2 border-b border-gray-200">{{ product.status }}</td>
                        <td class="px-3 py-2 border-b border-gray-200">{{ formatDate(product.productionDate) }}</td>
                        <td class="px-3 py-2 border-b border-gray-200">{{ formatDate(product.deliveryDate) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import localization from '../../mixins/localization';

export default {
    mixins: [localization],
    props: {
        products: {
            type: Array,
            required: true,
        },
    },
    computed: {
        organizedProducts() {
            const parents = [];
            const childrenByParent = {};

            // Separate parents and children
            this.products.forEach(product => {
                if (product.isGroup) {
                    // This is a parent group
                    parents.push(product);
                    if (!childrenByParent[product.productId]) {
                        childrenByParent[product.productId] = [];
                    }
                } else if (product.groupId) {
                    // This is a child of a group
                    if (!childrenByParent[product.groupId]) {
                        childrenByParent[product.groupId] = [];
                    }
                    childrenByParent[product.groupId].push(product);
                } else {
                    // Standalone product (no group)
                    parents.push(product);
                }
            });

            // Build final structure with children nested
            const result = [];
            parents.forEach(parent => {
                result.push({ ...parent, isParent: true });

                // Add children if this is a group
                if (parent.isGroup && childrenByParent[parent.productId]) {
                    childrenByParent[parent.productId].forEach(child => {
                        result.push({ ...child, isChild: true });
                    });
                }
            });

            return result;
        }
    },
    methods: {
        formatDate(date) {
            if (!date) {
                return '-';
            }

            return moment(date).format('DD/MM/YYYY');
        },
        getRowClass(product) {
            const workdaysRemaining = product.workdaysRemaining;

            if (workdaysRemaining <= 0) {
                return 'bg-red-800 text-white';
            }
            if (workdaysRemaining <= 2) {
                return 'bg-red-200';
            }
            if (workdaysRemaining <= 4) {
                return 'bg-amber-200';
            }

            return '';
        },
        getRowTitle(product) {
            if (product.workdaysRemaining != null) {
                return this.trans('production_progress.workdays', {
                    count: product.workdaysRemaining,
                });
            }

            return '';
        },
    },
};
</script>
